import { render, staticRenderFns } from "./Sellers.vue?vue&type=template&id=b0dad120&"
import script from "./Sellers.vue?vue&type=script&lang=js&"
export * from "./Sellers.vue?vue&type=script&lang=js&"
import style0 from "./Sellers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports